// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-common----social-media-link-list-module---container---1r7ic"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/social-media-link-list.module.scss
// module id = 263
// module chunks = 36434998819415 79611799117203 125193764933041